export default {
  data() {
    return {
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL
    };
  },
  methods: {
    fileIcon(filename) {
      switch (filename.split(".").pop()) {
        case "pdf":
          return "mdi-file-pdf";
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
          return "photo_size_select_actual";
        default:
          return "description";
      }
    },
    fileIconColor(filename) {
      switch (filename.split(".").pop()) {
        case "pdf":
          return "error";
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
          return "orange";
        default:
          return "blue";
      }
    }
  }
};
